<template>
  <v-container>
    <v-navigation-drawer app v-model="appevent.openSideMenu">
      <v-list nav style="background-color: transparent;">
          <MainMenuItem toName="WelcomeView" :imgSrc='require("@IMG/dashboard.svg")' titleContent="Accueil"/>
          <MainMenuItem toName="CandidatesView" :imgSrc='require("@IMG/taureau_green.svg")' titleContent="Candidats"/>
          <MainMenuItem toName="CustomersView" :imgSrc='require("@IMG/ours_blue.svg")' titleContent="Clients"/>
          <MainMenuItem toName="OppView" :imgSrc='require("@IMG/lynx_red.svg")' titleContent="Opportunités"/>
      </v-list>
    </v-navigation-drawer>

    <div>
        <!-- Main content will be rendered here -->
        <router-view/>
    </div>
  </v-container>
</template>

<script>
import MainMenuItem from '@/components/MainMenuItem.vue' // Assurez-vous que le chemin est correct
import { AppEventsStore } from '@/stores'

export default {
  name: 'DashboardLayout',
  data: () => ({
    drawer: false // Contrôle l'état du menu latéral
  }),
  computed: {
    appevent: function () {
      return AppEventsStore()
    }
  },
  components: {
    MainMenuItem
  }
}
</script>

<style>
v-list-item-icon {
  display: flex;
  justify-content: center;
}

.main_menu_button {
  position: fixed; /* Utilisez fixed pour positionner l'élément par rapport à la fenêtre du navigateur */
  top: 5px;
  left: 5px;
  float: left;
  cursor: pointer; /* Change le curseur en main pour indiquer que c'est cliquable */
  z-index: 888888;
}
</style>
